import { Stack } from '@mui/material';
import { Page } from 'components/Page';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import { achievementsTabPath, categoriesListTabPath, journalTabPath, profileTabPath, rootPath } from 'navigation/paths';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { FloatingTabbar } from './tabbar/FloatingTabbar';
import { VoiceTabbarButton } from './voice/VoiceTabbarButton';

export const TabLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const journalEnabled = useFeatureFlag('journal');
  const { t } = useTranslation('common');

  const tabs = useMemo(() => [
    { id: 'quests', text: t('tabs.quests'), icon: 'explore', path: rootPath },
    { id: 'achievements', text: t('tabs.achievements'), icon: 'emoji_events', path: achievementsTabPath },
    { id: 'categories', text: t('tabs.categories'), icon: 'category', path: categoriesListTabPath },
    ...(journalEnabled
      ? [{ id: 'journal', text: t('tabs.journal'), icon: 'menu_book', path: journalTabPath }]
      : []),
    { id: 'profile', text: t('tabs.profile'), icon: 'settings', path: profileTabPath },
  ], [journalEnabled, t]);

  const currentTabId =
    tabs
      .filter((t) => t.path !== '/')
      .find((tab) => pathname === tab.path || pathname.startsWith(tab.path + '/'))?.id ?? 'quests';

  return (
    <Page
      back={false}
      insetEnabled={false}
      edgeToEdge
      footer={
        <FloatingTabbar
          tabs={tabs}
          selectedId={currentTabId}
          onSelect={(id) => {
            const tab = tabs.find((t) => t.id === id);
            if (tab) navigate(tab.path);
          }}
          action={<VoiceTabbarButton currentTabId={currentTabId} />}
        />
      }
    >
      <Stack height="100%">
        <Outlet />
      </Stack>
    </Page>
  );
};
